import {
	ChangeDetectionStrategy,
	Component,
	inject,
	signal,
	WritableSignal,
	OnInit,
} from '@angular/core';

import { MatDialogRef } from '@angular/material/dialog';
import { DeleteConfirmComponent } from '@core/dialogs/delete-confirm/delete-confirm.component';
import { MatRippleModule } from '@angular/material/core';
import { SelectionModel } from '@angular/cdk/collections';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DatabaseService } from '@app/database/database.service';
import { IBuilding } from '@shared/interfaces/building.interfaces';
import { MatIconModule } from '@angular/material/icon';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'view-folder-copy',
	templateUrl: './view-folder-copy.component.html',
	styleUrls: ['./view-folder-copy.component.scss'],
	imports: [MatCheckboxModule, MatIconModule, MatRippleModule, NgxTolgeeModule],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewFolderCopyComponent implements OnInit {
	private readonly dbService = inject(DatabaseService);
	selection = new SelectionModel<any>(true, []);

	// all buildings
	buildings: WritableSignal<IBuilding[]> = signal([]);

	ngOnInit() {
		this.dbService.buildings
			.toArray()
			.then(buildings =>
				this.buildings.set(buildings.sort((a, b) => a.name.localeCompare(b.name)))
			);
	}

	constructor(private dialogRef: MatDialogRef<DeleteConfirmComponent>) {}

	checkboxChangeHandler(event: { source: any; checked: boolean }, item: any) {
		if (event.checked) {
			this.selection.select(item);
		} else {
			this.selection.deselect(item);
		}
	}

	copyButtonClicked() {
		this.dialogRef.close(this.selection.selected);
	}
}
